module.exports = __webpack_public_path__ + "img/softinya-prop-4.2c9b6c1a.webp";